<template>
	<div>
		<Navigation />
		<b-container>
			<b-row>
				<b-col col lg="12">
					<p style="margin-bottom: 0px;">Employees</p>
					<b-card bg-variant="light">
						<b-row>
							<b-col col lg="3" sm="12">
								<b-button @click="goTo('Workers')" variant="outline-primary" class="title button">{{$lang.modules.workers}}</b-button>
							</b-col>
							<b-col col lg="3" sm="12">
								<b-button @click="goTo('Attendance')" variant="outline-primary" class="title button">{{$lang.modules.attendance}}</b-button>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
		<b-container>
			<b-row>
				<b-col col lg="12">
					<p style="margin-bottom: 0px;">{{$lang.modules.finnance}}</p>
					<b-card bg-variant="light">
						<b-row>
							<b-col col lg="3" sm="12">
								<b-button @click="goTo('PurchaseOrders')" variant="outline-primary" class="title button">{{$lang.finnance.purchaseOrders.title}}</b-button>
							</b-col>
							<b-col col lg="3" sm="12">
								<b-button @click="goTo('Invoices')" variant="outline-primary" class="title button">{{$lang.finnance.invoices.title}}</b-button>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
		<b-container>
			<b-row>
				<b-col col lg="12">
					<p style="margin-bottom: 0px;">{{$lang.modules.computingMetrics}}</p>
					<b-card bg-variant="light">
						<b-row>
							<b-col col lg="3" sm="12">
								<b-button @click="goTo('ComputingMetrics')" variant="outline-primary" class="title button">{{$lang.computingMetrics.title}}</b-button>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</b-container>
		<b-container>
			<b-row>
				<b-col col lg="12">
					<p style="margin-bottom: 0px;">Settings</p>
					<b-card bg-variant="light">
						<b-row>
							<b-col col lg="3" sm="12" style="padding-bottom:30px;">
								<b-button @click="goTo('CostCenter')" variant="outline-primary" class="title button">{{$lang.settings.costCenter.new}}</b-button>
							</b-col>
							<b-col col lg="3" sm="12" style="padding-bottom:30px;">
								<b-button @click="goTo('Contracts')" variant="outline-primary" class="title button">{{$lang.settings.contracts.title}}</b-button>
							</b-col>
							<b-col col lg="3" sm="12" style="padding-bottom:30px;">
								<b-button @click="goTo('Providers')" variant="outline-primary" class="title button">{{$lang.settings.providers.title}}</b-button>
							</b-col>
						</b-row>
					</b-card>
				</b-col>
			</b-row>
		</b-container>

	</div>
</template>

<script>
import Navigation from './Navigation.vue'

export default {
	data() {
		return {

		}
	},

	components: { Navigation },

	methods: {
		goTo(routeName) {
			this.$store.commit('setCurrentRoute', routeName)
			this.$router.push({name: routeName}).catch(err => {
				console.log(err)
			})
		}
	}
}
</script>

<style>
.button {
	margin-right: 10px;
	width: 100%
}

</style>